var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChart = function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    fill: "none",
    viewBox: "0 0 38 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#236A91",
    d: "M3.563 2.156c0-.987-.795-1.781-1.782-1.781S0 1.169 0 2.156v26.125a5.34 5.34 0 0 0 5.344 5.344h30.875c.987 0 1.781-.794 1.781-1.781 0-.987-.794-1.782-1.781-1.782H5.344a1.777 1.777 0 0 1-1.782-1.78V2.155Zm31.543 8.387a1.774 1.774 0 0 0 0-2.516 1.78 1.78 0 0 0-2.517 0l-8.832 8.832-5.863-5.863a1.78 1.78 0 0 0-1.262-.52 1.78 1.78 0 0 0-1.261.52L8.246 18.12a1.774 1.774 0 0 0 0 2.516 1.78 1.78 0 0 0 2.516 0l5.863-5.864 5.863 5.864a1.774 1.774 0 0 0 2.516 0l10.101-10.094Z"
  })));
};
export default SvgChart;